import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { updateCacheByType } from '../../../graphql/GraphQlProvider';
import { GroupBooking } from '../../../graphql/groups.datatypes';
import { gqlGroupBooking } from '../getGroupBooking.api';

export interface CreateGroupBookingInput {
  data: {
    group_id: number
    start_date: string
    end_date: string
    disabled: boolean
    soft_cancelled: boolean
  }
}

interface CreateGroupBookingData {
  createGroupBooking: GroupBooking
}

export const CREATE_GROUP_MUTATION = gql`
    mutation createGroupBooking($data: CreateGroupBookingInput!) {
        createGroupBooking(data: $data) {
            ${gqlGroupBooking}
        }
    }
`;

export const createGroupBooking = () => useMutation<CreateGroupBookingData, CreateGroupBookingInput>(
  CREATE_GROUP_MUTATION,
  {
    update: updateCacheByType('GroupBooking'),
  }
);

export default createGroupBooking;